import React from 'react';
import api from '../api';
import { createMuiTheme, makeStyles, MuiThemeProvider, Paper, MenuItem, Switch, Tabs, Tab, Typography, withStyles, Menu, Tooltip } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import IconButton from '@material-ui/core/IconButton';
import ExpandMore from '@material-ui/icons/ExpandMore'
import EditJadwal from './editJadwal';
import Loader from 'react-loader-spinner'
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseImage from '../../assets/ic_close.png';
import { TextField } from '@material-ui/core';
import ActionDetailJadwalDokter from './actionDetailJadwalDokter';
import { Link, useHistory, useLocation } from 'react-router-dom';
import aksi from '../../assets/1@3x.png';
import ic_detail from '../../assets/ic_detail.png';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function DetailJadwalDokter() {
    const history = useHistory()
    const before_cron = new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 23:50`)
    const year_cron = before_cron.getFullYear()
    const date_cron = before_cron.getDate() < 10 ? `0${before_cron.getDate()}` : before_cron.getDate()
    const month_cron = before_cron.getMonth() + 1 < 10 ? `0${before_cron.getMonth() + 1}` : before_cron.getMonth() + 1
    const time_cron = 23
    const created = `${year_cron}-${month_cron}-${date_cron}`
    console.log(before_cron);
    const [flagEdit, setFlagEdit] = React.useState(false)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [visibleAction, setVisibleAction] = React.useState(false)
    const location = useLocation()
    let efDate;
    // console.log(props);
    const classes = useStyles()
    let detail = location.state.detail[0]
    console.log(location, '<<<<<<');
    detail.effective_date.map((el, idx) => {
        if (el.date === location.state.efDate) {
            // console.log(el, '-----');
            detail = el
            efDate = el.date
        }
    })
    const [data, setData] = React.useState(null)
    const [hari, setHari] = React.useState(null)
    const [time_start, set_time_start] = React.useState(new Date())
    const [time_end, set_time_end] = React.useState(new Date())
    const [time_type, set_time_type] = React.useState(null)
    const [time, set_time] = React.useState(null)
    const [quota, set_quota] = React.useState(null)
    const [list_room, set_list_room] = React.useState([])
    const [quota_bpjs, set_quota_bpjs] = React.useState(null)
    const [service_type, set_service_type] = React.useState(null)
    const [service_duration, set_service_duration] = React.useState(null)
    const [position, setPosition] = React.useState({})
    const [room, set_room] = React.useState(null)
    const [sentData, setSentData] = React.useState([])
    const [refreshData, setRefreshData] = React.useState([])
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [visibleDelete, setVIsibleDelete] = React.useState(false);
    const [rawData, setRawData] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const ITEM_HEIGHT = 48;

    React.useEffect(() => {
        refresh()
    }, [])


    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleStatus = ({ rowData }) => {
        setVIsibleDelete(true)
        setRawData(rowData)
        // console.log(rowData);
    }

    const changeStatus = () => {
        console.log(rawData);
        let payload = {
            "id": rawData[19],
            "activeinactive": rawData[11] === null ? 0 : 1
        }
        console.log(JSON.stringify(payload));
        api.create().editMasterJadwal(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setVIsibleDelete(false)
                    refresh()
                }
            }
        })
    }

    const columns = [
        {
            name: "hari",
            label: "Hari"
        },
        {
            name: "time_start",
            label: "Jam Mulai"
        },
        {
            name: "time_end",
            label: "Jam Selesai"
        },
        {
            name: "time_type",
            label: "Tipe Antrian"
        },
        {
            name: "time",
            label: "Slot Waktu"
        },
        {
            name: "service_duration",
            label: "Durasi Layanan"
        },
        {
            name: "quota",
            label: "Kuota Pasien"
        },
        {
            name: "quota_bpjs",
            label: "Kuota BPJS"
        },
        {
            name: "service_type",
            label: "Layanan"
        },
        {
            name: "room",
            label: "Lokasi Praktek"
        },
        {
            name: "remarks",
            label: "Catatan"
        },
        {
            name: "deleted_at",
            label: "Status",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div>
                            {val === null ? 'Active' : "Inactive"}
                        </div>
                    )
                }
            }
        },
        {
            name: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    let timeData = new Date(tableMeta.rowData[11])
                    let dateData = timeData.getDate() < 10 ? `0${timeData.getDate()}` : timeData.getDate()
                    let monthData = timeData.getMonth() + 1 < 10 ? `0${timeData.getMonth() + 1}` : timeData.getMonth() + 1
                    let yearData = timeData.getFullYear()
                    let waktu = timeData.getHours() < 10 ? `0${timeData.getHours()}` : timeData.getHours()
                    let b = `${yearData}-${monthData}-${dateData}`
                    // console.log(created ===  b && waktu < time_cron);
                    // console.log(waktu < time_cron);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <IconButton
                                style={{ outline: 'none' }}
                                title={created === b && waktu < time_cron ? "Edit" : "Detail"}
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true"
                                onClick={(e) => {
                                    if (created === b && waktu < time_cron) {
                                        setSentData(tableMeta.rowData)
                                        forceUpdate()
                                        handleEdit(e, tableMeta, true)
                                    } else {
                                        setSentData(tableMeta.rowData)
                                        forceUpdate()
                                        handleEdit(e, tableMeta, false)
                                    }
                                }}
                            >
                                {
                                    created === b && waktu < time_cron ?
                                        <img src={aksi} style={{ width: 30, height: 30 }} />
                                        :
                                        <img src={ic_detail} style={{ width: 30, height: 30 }} />
                                }
                            </IconButton>
                            {location.state.deleted && (
                                <LightTooltip title={`${tableMeta.rowData[11] !== null ? 'Inactive' : 'Active'}`} arrow>
                                    <button style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}
                                        onClick={() =>
                                            tableMeta.rowData[11] === null ? handleStatus(tableMeta) : null
                                        }>
                                        <IconSwitch checked={tableMeta.rowData[11] !== null ? false : true} />
                                    </button>
                                </LightTooltip>
                            )}
                        </div>
                    )
                }
            }
        },
        {
            name: "created_at",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "created_by",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "updated_at",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "updated_by",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "deleted_at",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "deleted_by",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "internal_notes",
            options: {
                display: false,
                filter: false
            }
        }
    ];

    const onClose = () => {
        setVisibleAction(false)
    }

    const handleEdit = (e, tableMeta, bool) => {
        console.log(bool);
        if (tableMeta.rowData.length >= 1) {
            history.push({
                pathname: "/masterdata/edit-jadwal",
                name: 'Edit Master Jadwal Dokter',
                state: {
                    sentData: tableMeta.rowData,
                    efDate,
                    detail: location.state.detail,
                    name: location.state.dokterName,
                    isEdit: bool,
                    value: location.state.value
                }
            })
            console.log(tableMeta.rowData);
        }
    }

    const refresh = () => {
        api.create().getDokterSchedule(location.state.value.doctor_detail_id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let tempDokter = response.data.data
                    let tempPoli;
                    let tempDate;
                    let temp = []
                    if (tempDokter != false) {
                        tempDokter.map((el, idx) => {
                            tempPoli = el.polyclinic
                            tempPoli.map(item => {
                                tempDate = item.effective_date
                                tempDate.map((elemen, index) => {
                                    if (elemen.date === location.state.efDate) {
                                        elemen["no"] = index + 1
                                        temp.push(elemen)
                                    }
                                })
                            })
                        })
                        setRefreshData(temp)
                    } else {
                        setRefreshData([])
                    }
                }
            }
        })
    }

    // console.log(refreshData);

    return (
        <div>
            <div style={{ position: 'absolute', top: 50, zIndex: 2 }}>
                <Typography style={{ paddingTop: 30, paddingLeft: 20, color: "#278863" }}>{location.state.dokterName}</Typography>
                <Typography style={{ paddingTop: 10, paddingLeft: 20, color: "#a4a4a4", fontSize: 15 }}>Klinik {location.state.detail[0].polyclinic_name}</Typography>
            </div>
            <div style={{ marginTop: 20 }}>
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={refreshData != false ? refreshData[0].schedule : detail.schedule}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
            {visibleDelete && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVIsibleDelete(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin mengganti status Jadwal tersebut?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVIsibleDelete(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatus()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}